export default __webpack_public_path__ + "static/media/feature1_7.a9a22221.png";